import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogTitle from '@material-ui/core/DialogTitle';
import { withStyles } from '@material-ui/core/styles';
import PropTypes from 'prop-types';
import React from 'react';
import CancelButton from '../../core/CancelButton';
import { globalStyles } from '../../core/style/gstheme';
import CollectionSelector from './CollectionSelector';

const styles = Object.assign({}, globalStyles);

class CollectionSelectorDialog extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            open: false
        };
    }

    handleClickOpen = () => this.setState({ open: true });

    selectCollection = (iri) => {
        this.setState({ open: false });
        this.props.onSelectCollection(iri);
    };

    exitSelectCollection = () => this.setState({ open: false });

    render() {

        const { classes, button, projectIRI, conceptIRI, defaultLang, graph } = this.props;

        return (
            <React.Fragment>
                <span onClick={this.handleClickOpen}>{button}</span>
                {this.state.open &&
                    <Dialog data-test="select-collection" classes={{ paper: classes.paper }}
                        className={classes.dialog} open={this.state.open}
                        onClose={this.exitSelectCollection} aria-labelledby="selectioncollection-dialog-title">
                        <DialogTitle disableTypography className={classes.mainHeading} id="selectioncollection-dialog-title">Select a Collection</DialogTitle>
                        <DialogContent>
                            <CollectionSelector
                                onSelectCollection={this.selectCollection}
                                conceptIRI={conceptIRI}
                                id={projectIRI}
                                graph={graph}
                                defaultLang={defaultLang} />
                        </DialogContent>
                        <DialogActions className={classes.dialogActions}>
                            <CancelButton onClick={this.exitSelectCollection} />
                        </DialogActions>
                    </Dialog>
                }
            </React.Fragment>
        );
    }
}

CollectionSelectorDialog.propTypes = {
    button: PropTypes.object.isRequired,
    projectIRI: PropTypes.string.isRequired,
    defaultLang: PropTypes.string.isRequired,
    conceptIRI: PropTypes.string.isRequired,
    onSelectCollection: PropTypes.func.isRequired,
    classes: PropTypes.object
};

export default withStyles(styles)(CollectionSelectorDialog);